<template>
  <TicketCountListbox
    v-model="selected"
    :item="item"
    :options="options"
    :title="selected ? $t('Update or clear tickets') : $t('Add tickets to your cart')" />
</template>

<script setup>
const { event, ticket } = defineProps({
  event: { required: true },
  ticket: { required: true },
});

import { ref, watch } from "vue";
import { isB2C } from "@/brandconfig";
import { useEventStore } from "@/store/event.js";
const eventStore = useEventStore();
eventStore.fetchSubcategoryTickets(ticket).then((tickets) => {
  options.value = createTicketCountOptions(tickets, MAX);
});

import { useUserStore } from "@/store/user.js";
const userStore = useUserStore();

const ADMIN_MAX = 1000;
const USER_MAX = 100;
const BRANDED_MAX = event.sport_type == "formula1" || event.sport_type == "soccer" ? 10 : undefined;
const MAX = (userStore.isAdmin && ADMIN_MAX) || (isB2C && BRANDED_MAX) || USER_MAX;

import { useCartStore } from "@/store/cart.ts";
const cartStore = useCartStore();

import { TicketCountListbox } from ".";
import { createTicketCountOptions } from "@/helpers/subcategories";

cartStore.getTicketAmount(ticket.ticket_id);
const options = ref([]);
//const selected = ref({ n: amount })

const item = cartStore.getSubcategoryItem(event, ticket);
const selected = ref(item.amount);

watch(selected, async (amount, old_amount) => {
  if (amount === old_amount) return;
  cartStore.updateTicketAmount(event, ticket, amount);
});

/*
const selected = ref(item.amount)

watch(item, ({ amount }) => {
  selected.value = amount
})

watch(selected, (amount) => {
  if (amount !== subcategory.amount) {
    cartStore.updateTicketAmount(event, subcategory, amount)
  }
})
*/
</script>
